import { render, staticRenderFns } from "./vue-tel-input.vue?vue&type=template&id=b8182502&"
import script from "./vue-tel-input.vue?vue&type=script&lang=js&"
export * from "./vue-tel-input.vue?vue&type=script&lang=js&"
import style0 from "../assets/component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/architect/projects/gadzoom/gadzoom-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8182502')) {
      api.createRecord('b8182502', component.options)
    } else {
      api.reload('b8182502', component.options)
    }
    module.hot.accept("./vue-tel-input.vue?vue&type=template&id=b8182502&", function () {
      api.rerender('b8182502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/registration/vue-tel-input/components/vue-tel-input.vue"
export default component.exports